import {Card} from "@material-ui/core";
import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {PresenceZoneForm} from "./PresenceZoneForm";

export const PresenceZoneEdit = (props: EditProps) => {
  return (
    <DefaultEdit {...props} component={Card}>
      <PresenceZoneForm />
    </DefaultEdit>
  );
};
